<template>
    <div v-show="mostrar" class="modal-backdrop fade show" id="backdrop"></div>
    <div class="modal d-block" role="dialog" v-if="mostrar">
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered fade show larguraMaxima"
            :style="{ 'maxWidth': tamanhoModal + '%' }">
            <!-- :class="{'modalLargo': true}" -->
            <div class="modal-content">
                <div class="modal-header mb-2 mx-0 row" :style="retornaFundo()">
                    <slot name="header" />
                </div>
                <div class="modal-body mb-2 g-3" :class="{ 'scroll': modalLargo }">
                    <slot name="corpo" />
                </div>
                <div class="modal-footer">
                    <slot name="rodape" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import store from '@/store/store';
import { relativeTimeRounding } from 'moment';
import { reactive, onMounted, computed, defineProps, defineEmits } from 'vue';

const props = defineProps(['mostrar', 'modalLargo', 'tamanhoModal', 'relatorio']);
const emits = defineEmits(['fechar']);

onMounted(() => {
    cronometro();
});

function cronometro() {
    setTimeout(() => {
        setInterval(() => {
            if (props.mostrar) {
                // emits("fechar");
            }
        }, 1000 * config.value.atualizacao);
    }, 2000);
}

function retornaFundo() {
    if (props.relatorio == true) {
        return "background-color: var(--corNav)";
    }
}

const config = computed(() => {
    return store.state.config;
});
</script>

<style scoped>
.modal-body,
.modal-footer {
    justify-content: center;
}

.mb-2 {
    margin-bottom: 2px !important;
}

.modalLargo {
    max-width: 60% !important;
}

.scroll {
    height: 750px;
    overflow: auto;
}

@media only screen and (max-width: 575px) {
    .larguraMaxima {
        max-width: 100% !important;
    }
}

/*

@media only screen and (min-width: 575px) {
    .larguraMaxima {
        max-width: 70% !important;
    }
}*/
</style>